import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";

import eyeIcon from "../../../assets/Icons/eye.svg";
import { useTranslation } from "react-i18next";


export const LoginStyle = createGlobalStyle`
  html {
    font-size: 1vw;
  }
  
  body {
    margin: 0;
    font-family: Abraham;
  }
`;

export default function LoginForm({login, loading}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const passwordIconStyle = showPassword ? null : {opacity: "30%"};

  const handleChange = (setState) => (event) => {setState(event.target.value)};

  const onShowPassword = () => {
    setShowPassword(!showPassword);
  }

  return (
    <>
    <LoginStyle />
    <FormContainer>
      <InputWraper>
        <Input 
          placeholder={t("login-emailPlaceHolder")} 
          style={{marginBottom: "2.77vh"}}  
          error={errorMessage}
          onChange={handleChange(setEmail)}
          value={email}
          type="email"
          disabled={loading}
        />
      </InputWraper>
      <InputWraper>
        <Input 
          placeholder={t("login-passwordPlaceHolder")} 
          error={errorMessage}
          onChange={handleChange(setPassword)}
          value={password}
          type={showPassword ? "text" : "password"}
          disabled={loading}
        />
        <InputIcon 
          style={passwordIconStyle} 
          src={eyeIcon}
          onClick={onShowPassword}
          title={showPassword ? t("login-hidePassword") : t("login-showPassword")}
        /> 
      </InputWraper>
      <ErrorWrapper>
        {errorMessage &&
          <ErrorMessage>{errorMessage}</ErrorMessage>
        }
      </ErrorWrapper>
      <ForgotPwText onClick={() => navigate("/forgot-password")}>{t("login-forgotPassword")}</ForgotPwText>
      <Button disabled={loading} onClick={() => login({email, password})}>
        {loading ? t("login-signingIn") : t("login-signIn")}
      </Button>
    </FormContainer>
    </>
  );
}


const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 19rem;
`

const BlockedMessage = styled.p`
  font-size: 1.2rem;
  font-weight: 500;
  color: #F02A4C;
  text-align: center;
  margin: 0;
  margin-bottom: 2rem;
  line-height: 1.5;
`

const ContactButton = styled.button`
  width: 8.85rem;
  height: 4.62vh;

  background: #F02A4C;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 29px;
  border: 0;

  font-size: 0.9375rem;
  font-weight: 400;
  color: white;
  cursor: pointer;
  
  &:hover {
    background: #d0253a;
  }
`

const ForgotPwText = styled.p`
  font-size: 0.9375rem;
  margin: 0;
  margin-bottom: 1vh;
  text-decoration: underline;
  cursor: pointer;
  color: #1A1A1A;

  &:hover {
    color: #F02A4C;
  }
`

const InputIcon = styled.img`
  position: absolute;
  height: 27px;
  width: 1.146rem;

  right: 0.6rem;
  top: 50%;
  transform: translateY(-50%);
`


const Input = styled.input`
  width: calc(100% - 2.9166rem);
  background: white;
  border-radius: 1.51rem;
  opacity: 0.8;
  border: ${(props) => props.error ? "2px solid #F02A4C;" : "0"};
  
  padding: 1.481vh 1.458rem 1.296vh 1.458rem;

  font-size: 0.9375rem;
  &::placeholder {
    opacity: 50%;
    font-size: 0.9375rem;
  }

  &:focus {
    outline: 0.1rem solid black;
  }
`

const InputWraper = styled.div`
  position: relative;
  width: 100%;
`

const ErrorWrapper = styled.div`
  min-height: 2.22vh;
  margin-block: 2.22vh;
`

const ErrorMessage = styled.p`
  color: #F02A4C;
  font-size: 0.9375rem;
  font-weight: 600;
  text-align: center;
  margin: 0;
`


const Button = styled.button`
  width: 8.85rem;
  height: 4.62vh;

  background: #F02A4C;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 29px;
  border: 0;

  font-size: 0.9375rem;
  font-weight: 500;
  font-family: Abraham;
  color: white;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #d0253a;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
